export const config = {
  apiUrl: process.env.REACT_APP_CLIENT_API_URL,
  s3BucketUrl: process.env.REACT_APP_CLIENT_S3_BUCKET_URL,
  assetUrl: process.env.REACT_APP_CLIENT_ASSET_URL,
  altImg: 'images/no_avatar_profile.jpg',
  baseUrl: process.env.REACT_APP_CLIENT_MAIN_URL + '/',
  altInvImg: 'images/inv_img.jpeg',
  mainUrl: process.env.REACT_APP_CLIENT_MAIN_URL,
  pusherKey: process.env.REACT_APP_CLIENT_PUSHER_KEY,
  pusherCluster: process.env.REACT_APP_CLIENT_PUSHER_CLUSTER,
  dsn: process.env.REACT_APP_CLIENT_DSN,
  navBgColor: process.env.REACT_APP_CLIENT_NAV_BG_COLOR,
  assetBrandName: process.env.REACT_APP_ASSET_BRAND_NAME,
  companyName: process.env.REACT_APP_COMPANY_NAME,
  companyNameFull: process.env.REACT_APP_COMPANY_NAME_FULL,
  companyNameAbbr: process.env.REACT_APP_COMPANY_NAME_ABBR,
  companyNameLegal: process.env.REACT_APP_COMPANY_NAME_LEGAL,
  companyNameWildland: process.env.REACT_APP_COMPANY_NAME_WILDLAND,
  companyNameSms: process.env.REACT_APP_COMPANY_NAME_SMS,
  companyAddress: process.env.REACT_APP_COMPANY_ADDRESS,
  companyPhone: process.env.REACT_APP_COMPANY_PHONE,
  companyEmail: process.env.REACT_APP_COMPANY_EMAIL,
  companyWebsite: process.env.REACT_APP_COMPANY_WEBSITE,
  companyFax: process.env.REACT_APP_COMPANY_FAX,
  companyOwnerName: process.env.REACT_APP_COMPANY_OWNER_NAME,
  showLogo: !(process.env.REACT_APP_SHOW_LOGO === 'false' || process.env.REACT_APP_SHOW_LOGO === '0'), // Defaults to true, set to 'false' or '0' to hide logo
};
